import { BUNDLE_DISCOUNT_ALLOCATION_TITLE } from 'lib/constants/bundle-discount';

type Allocation = {
  __typename?: string;
  title?: string;
  discountedAmount?: { amount?: string } | null;
};

type CartWithAllocations = {
  discountAllocations?: Allocation[] | null;
  lines?: { nodes?: Array<{ discountAllocations?: Allocation[] | null }> };
} | null;

const sumBundleAllocations = (allocations: Allocation[] | null | undefined) =>
  (allocations || []).reduce(
    (acc, allocation) =>
      allocation.__typename === 'CartAutomaticDiscountAllocation' &&
      allocation.title === BUNDLE_DISCOUNT_ALLOCATION_TITLE
        ? acc + parseFloat(allocation.discountedAmount?.amount || '0')
        : acc,
    0,
  );

// Sums the bundle25 Shopify Function's allocations at cart and line level,
// ignoring other automatic discounts (Subscribe & Save, free cobiotic) and codes.
export const getBundleDiscountTotal = (cart?: CartWithAllocations): number => {
  if (!cart) return 0;
  return (
    sumBundleAllocations(cart.discountAllocations) +
    (cart.lines?.nodes || []).reduce(
      (acc, line) => acc + sumBundleAllocations(line.discountAllocations),
      0,
    )
  );
};
